import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import FabricEstimator from "@/components/FabricEstimator";

const AdminPricingPage = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem("adminAuth") === "true";
  });

  // Check auth on mount
  useEffect(() => {
    const adminAuth = sessionStorage.getItem("adminAuth");
    if (adminAuth !== "true") {
      navigate("/admin");
    }
  }, [navigate]);

  if (!isAuthenticated) return null;

  return (
    <div className="min-h-screen pt-20">
      {/* Header */}
      <section className="py-12 border-b border-white/5">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12">
          <Button
            variant="ghost"
            onClick={() => navigate("/admin")}
            className="mb-4"
          >
            <ArrowLeft size={16} className="mr-2" />
            Back to Admin
          </Button>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <p className="mono-text text-primary mb-4">Admin Tools</p>
            <h1 className="font-serif text-3xl sm:text-4xl tracking-tight mb-4">
              Garment Cost Calculator
            </h1>
            <p className="text-muted-foreground text-sm">
              Calculate pricing using Kutesmart CMT costs • RCMTM 2022 Fabric Catalog
            </p>
          </motion.div>
        </div>
      </section>

      {/* Calculator */}
      <section className="py-12">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          {/* Enhanced Fabric Estimator with Cost Calculator */}
          <FabricEstimator />
        </div>
      </section>
    </div>
  );
};

export default AdminPricingPage;
